import { render, staticRenderFns } from "./Historico.vue?vue&type=template&id=12637da5&scoped=true"
import script from "./Historico.vue?vue&type=script&lang=ts"
export * from "./Historico.vue?vue&type=script&lang=ts"
import style0 from "./Historico.vue?vue&type=style&index=0&id=12637da5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12637da5",
  null
  
)

export default component.exports